import { StandardEvents } from '@shopify/events';

const PRICE = 52580141039896;
const AUXILIARY = new Set([52618410328344, 52593530405144, 52613031919896]);
const listeners = new Set();
let latest;
let generation = 0;

export function commercialCount(items, decode = globalThis.SCDM_COLIS?.decode) {
  const unknown = { count: null, empty: false };
  if (!Array.isArray(items)) return unknown;
  let count = 0;
  for (const item of items) {
    const id = Number(item.variant_id ?? item.id);
    if (!Number.isSafeInteger(id) || id < 1 || !Number.isSafeInteger(item.quantity) || item.quantity < 1) return unknown;
    if (AUXILIARY.has(id)) continue;
    if (id !== PRICE) {
      count += item.quantity;
      if (!Number.isSafeInteger(count)) return unknown;
      continue;
    }
    const props = item.properties || {};
    const quantity = props['Quantité'];
    const descriptor = props._scdm_shipping_v1;
    const detail = props['Détail'];
    if (!descriptor && !quantity && (detail === 'Montage du laminage — passe de lamination, une seule fois par commande' || /^Ajustement — minimum de commande de [1-9]\d*(?:[.,]\d{1,2})? \$$/.test(detail || ''))) continue;
    let realQuantity;
    if (quantity !== undefined && quantity !== null && quantity !== '') {
      const match = String(quantity).match(/^([1-9]\d{0,4})(?: autocollants?| stickers?)?$/);
      if (!match || Number(match[1]) > 10000) return unknown;
      realQuantity = Number(match[1]);
    }
    if (descriptor) {
      if (typeof decode !== 'function') return unknown;
      try {
        const decoded = decode(descriptor);
        if (realQuantity !== undefined && realQuantity !== decoded.qte) return unknown;
        realQuantity = decoded.qte;
      } catch (_) { return unknown; }
    }
    if (!Number.isSafeInteger(realQuantity) || realQuantity < 1 || realQuantity > 10000) return unknown;
    count += realQuantity;
    if (!Number.isSafeInteger(count)) return unknown;
  }
  return { count, empty: items.length === 0 };
}

export function countFromResult(result) {
  const items = result?.detail?.items;
  const total = result?.cart?.totalQuantity;
  if (!Array.isArray(items) || !Number.isSafeInteger(total) || total < 0 || items.reduce((sum, item) => sum + item.quantity, 0) !== total) return { count: null, empty: false };
  return commercialCount(items);
}

export function watchCartCount(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function emit(state) {
  latest = state;
  for (const listener of listeners) listener(state);
}

export function cartCountAnnouncement(state) {
  const source = document.querySelector('scdm-commercial-count');
  const label = source?.getAttribute('data-label') || '';
  const cartLabel = source?.getAttribute('data-cart-label') || '';
  return state.count === null || (state.count === 0 && !state.empty) ? cartLabel : `${label}: ${state.count}`;
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const current = ++generation;
  emit({ count: null, empty: false });
  event.promise?.then((result) => {
    if (current === generation) emit(countFromResult(result));
  }).catch(() => {
    if (current === generation) emit({ count: null, empty: false });
  });
});
document.addEventListener('cart:update', () => { generation++; emit({ count: null, empty: false }); });
window.addEventListener('pageshow', (event) => {
  if (event.persisted) { generation++; emit({ count: null, empty: false }); }
});

class CommercialCartCount extends HTMLElement {
  static get observedAttributes() { return ['data-items', 'data-native-total']; }
  attributeChangedCallback() {
    if (this.isConnected) this.paint(this.snapshot());
  }
  connectedCallback() {
    this.unsubscribe = watchCartCount((state) => this.paint(state));
    this.refresh = () => this.paint(latest || this.snapshot());
    window.addEventListener('load', this.refresh);
    this.refresh();
  }
  disconnectedCallback() {
    this.unsubscribe?.();
    window.removeEventListener('load', this.refresh);
  }
  snapshot() {
    try {
      const total = this.getAttribute('data-native-total');
      if (!/^\d+$/.test(total || '')) return { count: null, empty: false };
      const items = JSON.parse(this.getAttribute('data-items') || 'null');
      if (Array.isArray(items)) {
        for (const item of items) {
          const descriptor = item?.properties?._scdm_shipping_v1;
          if (typeof descriptor === 'string' && /^\{&quot;/.test(descriptor)) {
            item.properties._scdm_shipping_v1 = descriptor.replace(/&quot;/g, '"');
          }
        }
      }
      return countFromResult({ cart: { totalQuantity: Number(total) }, detail: { items } });
    }
    catch (_) { return { count: null, empty: false }; }
  }
  paint(state) {
    this.countState = state;
    const count = state.count;
    if (this.hasAttribute('data-accessible')) {
      this.textContent = count === null || (count === 0 && !state.empty) ? this.getAttribute('data-cart-label') : `${this.getAttribute('data-label')}: ${count}`;
    } else {
      const limit = Number(this.getAttribute('data-limit'));
      this.textContent = count === null || count === 0 ? '' : limit > 0 && count >= limit ? `${limit - 1}+` : String(count);
    }
  }
}

if (!customElements.get('scdm-commercial-count')) customElements.define('scdm-commercial-count', CommercialCartCount);


/* THEME 26 — photo GF 110 dans Matériaux uniquement. */
(function () {
  var photoGF110 = 'https://cdn.shopify.com/s/files/1/1001/0184/9368/files/scdm-materiaux-gf-110-erasemark-v2.png?v=1790342844';
  function actualiserPhotoGF110() {
    document.querySelectorAll('img[alt="GF 110 EraseMark PRO™"]').forEach(function (image) {
      if (image.getAttribute('src') !== photoGF110) {
        image.setAttribute('src', photoGF110);
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', actualiserPhotoGF110);
  else actualiserPhotoGF110();
  new MutationObserver(actualiserPhotoGF110).observe(document.documentElement, { childList: true, subtree: true });
})();
